import Repository from "./repository"

export default {
    /**
     * 契約情報取得処理
     * @param object params リクエストパラメータ
     * @returns response
     */
    get(params) {
        return Repository.get("/api/c206-contract-info/get", { params: params })
    },
}